function replacePlaceholders(str) {
  return str.replace(/{(.*?)}/g, (match, p1) => {
    return window[`__${p1}__`] || match;
  });
}
const processProxy = new Proxy(process.env, {
  get(target, p, receiver) {
    if (p in target) {
      return replacePlaceholders(target[p as string]);
    }
    return undefined;
  },
})

export default processProxy
